import { LayoutComponent } from "./component";
import { useCustomer } from "../../contexts/app/provider";
import { ROOT_ROLE } from "../../constants/user";

export const LayoutContainer = () => {
  const { whoIAm, loading, selectedCustomerId } = useCustomer();

  const role = whoIAm?.role || null;
  const customerId =
    role === ROOT_ROLE ? selectedCustomerId : whoIAm?.customerId || null;

  return <LayoutComponent customerId={customerId} loading={loading} />;
};
